import '../Scss/app.scss';

// Components
import events from './helpers/events';
import general from './core/general';
import footer from './components/footer';
import search from './components/search';
import filter from './components/news-filter';

// Import all
const modules = [general, footer, events, search, filter];
modules.forEach(module => {
  module();
});

// Dynamic components import
const components = [{
  el: 'header',
  fileName: 'core/header'
}, {
  el: 'video',
  fileName: 'components/video'
}, {
  el: '.ce-tabs',
  fileName: 'components/tab-slider'
}, {
  el: '.ce-card_group',
  fileName: 'components/card'
}, {
  el: '.ce-quote',
  fileName: 'components/quote'
}, {
  el: '.media__video--wrap',
  fileName: 'components/video-player'
}, {
  el: '.tabs',
  fileName: 'components/tabs'
}, {
  el: '.drx-downloads',
  fileName: 'components/downloads'
}, {
  el: '.ce-worldwide_locations',
  fileName: 'components/locations'
}, {
  el: '.js-more-less-toggle',
  fileName: 'components/more-less-toggle'
}, {
  el: '.powermail_form',
  fileName: 'components/powermail'
}, {
  el: 'select',
  fileName: 'components/select'
}, {
  el: '.js-dialog',
  fileName: 'vendors/dialog'
}, {
  el: '.table',
  fileName: 'components/scroll-shadow'
}];
const componentImport = async (el, fileName) => {
  if (!document.querySelector(el)) return;
  const module = await import(`./${fileName}`);
  // Initialize module
  if (typeof module === 'function') {
    module();
  } else if (typeof module === 'object' && typeof module.default === 'function') {
    module.default();
  }
};
components.forEach(component => {
  const {
    el,
    fileName
  } = component;
  componentImport(el, fileName);
});